import "./SignaturePopupComponent.scss";
import IconButtonComponent from "../icon-button/IconButtonComponent";
import {CloseIcon} from "../../../constants/ImageConfig";
import SignaturePadComponent from "../signature-pad/SignaturePadComponent";

interface SignaturePopupComponentProps {
    handleSignaturePopupClose: () => void;
    onSign?: (signImage: string | null) => void;
}

const SignaturePopupComponent = (props: SignaturePopupComponentProps) => {
    const {handleSignaturePopupClose,onSign} = props;

    return (
        <div className={'signature-popup-component'}>
            <div className={'signature-popup-header'}>
                <div className={'signature-popup-header-text'}>
                    Add Signature
                </div>
                <div className={'signature-popup-close-button'}>
                    <IconButtonComponent
                        onClick={()=>handleSignaturePopupClose()}
                    >
                        <CloseIcon/>
                    </IconButtonComponent>
                </div>
            </div>
            <div className={'signature-popup-pad-wrapper'}>
                <SignaturePadComponent note={" Note: Draw your signatures by using touch or pointer devices (mouse or stylus)"} onSign={onSign}/>
            </div>
        </div>
    );

};

export default SignaturePopupComponent;
